const cartNotes = document.querySelectorAll(".cartnote-element");
/* on first load, add a value to cart note: */
var finalNoteValue = "";
cartNotes.forEach((note) => {
  finalNoteValue = finalNoteValue + note.id + ": " + note.value + ";\r"
  //const noteValue = note.value;
  //console.log(noteValue);
  //console.log(note.id);
  //console.log(note.name);
});

console.log(finalNoteValue);

cartNotes.forEach((cartNote) => {
  cartNote.addEventListener("change", (event) => {
    var finalNoteValue = "";
    cartNotes.forEach((note) => {
      finalNoteValue = finalNoteValue + note.id + " :" + note.value + ";\r"
    });
    console.log(finalNoteValue);
    document.getElementById("Cart-note").value = finalNoteValue;
  });
});
